<div
  #specificContainer
  class="iu-specific-window iu-specific-window-container"
  [attr.data-cy-specific-window-name]="name">
  @if (!isModal && isLoading) {
    <p-progressBar [mode]="'indeterminate'" [value]="0" [showValue]="false" [styleClass]="'loading-progressbar'" />
  }

  <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
    <div class="p-col-12">
      <label [hidden]="title && title.length === 0" class="specific-title">
        <strong>{{ title }}</strong>
      </label>
      <div class="fields p-grid">
        <div class="p-col-4 p-md-4 p-lg-4">
          <ng-template iuDynamicContainer />
        </div>
        <div class="p-col-8 p-md-8 p-lg-8 p-grid">
          <div class="p-col-12 p-md-12 p-lg-12 p-grid">
            @if (selectedLocation$ | async; as selectedLocation) {
              <div class="p-col-6 p-md-6 p-lg-6 card-container">
                @for (oldColumn of oldColumns; track $index) {
                  <div
                    class="card"
                    draggable="true"
                    (dragstart)="onDragStart($event, oldColumn)"
                    (dragend)="onDragEnd($event)">
                    <iu-input-text-ui
                      [isStandalone]="true"
                      [isReadOnly]="true"
                      [fieldValue]="selectedLocation?.[oldColumn.columnName]"
                      [label]="oldColumn.label | translate" />
                  </div>
                }
              </div>

              <div class="p-col-6 p-md-6 p-lg-6 card-container">
                @for (newColumn of newColumns; track $index) {
                  <div class="card" (drop)="onDrop($event, newColumn)">
                    <iu-input-text-ui
                      [isStandalone]="true"
                      [isReadOnly]="false"
                      [fieldValue]="selectedLocation?.[newColumn.columnName]"
                      (fieldValueChange)="updateNLLocation(newColumn, $event)"
                      [label]="newColumn.label | translate" />
                  </div>
                }
              </div>
            }
          </div>
          <div class="p-col-12 p-md-12 p-lg-12 p-grid" style="justify-content: end">
            <iu-button-ui
              class="p-col-12 p-md-3 p-lg-2"
              (click)="saveNLLocation($event)"
              label="{{ 'generic.save' | translate }}"
              data-cy="location-migration-save" />
          </div>
        </div>
      </div>
    </div>
  </p-scrollPanel>
</div>
